/* EasyChina v5 — Global JS */

// LOADER
window.addEventListener('load', function() {
  setTimeout(function() {
    var l = document.getElementById('ec-loader');
    if (l) l.classList.add('gone');
  }, 1200);
  // Update rate ref text from localStorage on page load
  setTimeout(function() {
    var refEl = document.querySelector('.ec-rate-ref');
    if (refEl) {
      var cn = ecBuildRates('china');
      var txt = '<strong>Air ($/kg):</strong> Normal ' + cn.air.normal + ' · Clothes ' + cn.air.clothes + ' · Batteries/Magnetic ' + cn.air.batteries + ' · Liquid/Cosmetics/Powder ' + cn.air.liquid + '<br>';
      txt += '<strong>Sea ($/CBM):</strong> Normal ' + cn.sea.normal + ' · Clothes ' + cn.sea.clothes + ' · Batteries/Magnetic/Liquid/Cosmetics/Powder ' + cn.sea.batteries;
      refEl.innerHTML = txt;
    }
  }, 300);
});

// NAV SCROLL
var navGlass = document.querySelector('.ec-nav-glass');
if (navGlass) {
  window.addEventListener('scroll', function() {
    navGlass.classList.toggle('scrolled', window.scrollY > 20);
  }, { passive: true });
}

// DRAWER
function ecToggleDrawer() {
  var d = document.getElementById('ec-drawer');
  if (d) d.classList.toggle('open');
}

// CANVAS — Shipping World (Globe + Planes + Ships + Routes)
(function() {
  var c = document.getElementById('ec-canvas');
  if (!c) return;
  var ctx = c.getContext('2d');
  var W, H, T = 0, isMobile = false;
  var RAF;
  var SHIPS_INIT = false;

  // GLOBE_PARAMS — set by drawGlobe() each frame so drawCities() can place dots on the globe surface
  var GLOBE_PARAMS = { gx: 0, gy: 0, R: 1 };

  // Desktop: cities as [dx, dy] fractions of globe radius R, relative to globe center
  // (so a city at dx=0.4, dy=-0.3 sits 40% right and 30% up from globe center)
  var CITIES = [
    [+0.38, -0.30], // Beijing    — upper right (East China)
    [+0.46, -0.10], // Shanghai   — right, slightly above center
    [+0.42, +0.12], // Guangzhou  — right, slightly below center
    [-0.38, -0.32], // Istanbul   — upper left (Turkey)
    [+0.06, +0.20], // Dubai      — center-right, below equator
    [-0.18, +0.06], // Beirut     — slightly left of center
  ];

  // Mobile: spread cities across full canvas width, Y values stay in upper hero area
  var MOBILE_CITIES = [
    [0.90, 0.20], // Beijing     (far right, top)
    [0.82, 0.27], // Shanghai    (right)
    [0.74, 0.35], // Guangzhou   (right-center)
    [0.30, 0.19], // Istanbul    (left-center, top)
    [0.50, 0.30], // Dubai       (center)
    [0.12, 0.40], // Beirut      (far left, lower)
  ];

  var ROUTES = [[0,5],[1,5],[2,5],[3,5],[4,5]];

  var PLANES = [
    { route: 0, t: 0.1, spd: 0.0008, size: 17 },
    { route: 1, t: 0.6, spd: 0.0006, size: 14 },
    { route: 2, t: 0.3, spd: 0.0009, size: 16 },
    { route: 3, t: 0.8, spd: 0.0005, size: 13 },
  ];

  // Ships — 4 on desktop (all sizes), 2 on mobile
  var SHIPS = [
    { x: -80, y: 0.68, spd: 0.00038, size: 28 },
    { x: -80, y: 0.78, spd: 0.00026, size: 20 },
    { x: -80, y: 0.58, spd: 0.00031, size: 23 },
    { x: -80, y: 0.86, spd: 0.00020, size: 14 },
  ];

  function resize() {
    W = c.width = c.offsetWidth;
    H = c.height = c.offsetHeight;
    isMobile = W < 768;
    // Only set initial ship positions ONCE — never reset mid-animation
    // (mobile browser chrome show/hide triggers resize and would send boats back)
    if (!SHIPS_INIT) {
      SHIPS[0].x = isMobile ? W * 0.05 : -80;
      SHIPS[1].x = isMobile ? W * 0.55 : W * 0.35;
      SHIPS[2].x = isMobile ? W * 0.30 : W * 0.15;
      SHIPS[3].x = isMobile ? W * 0.70 : W * 0.62;
      SHIPS_INIT = true;
    }
  }

  function cityPx(i) {
    // Always globe-relative — dots placed ON the globe surface (mobile + desktop)
    var dc = CITIES[i];
    return { x: GLOBE_PARAMS.gx + dc[0] * GLOBE_PARAMS.R, y: GLOBE_PARAMS.gy + dc[1] * GLOBE_PARAMS.R };
  }

  function routePoint(fromIdx, toIdx, t) {
    var a = cityPx(fromIdx), b = cityPx(toIdx);
    var mx = (a.x + b.x) / 2;
    var my = Math.min(a.y, b.y) - H * (isMobile ? 0.18 : 0.18);
    var it = 1 - t;
    return {
      x:  it*it*a.x + 2*it*t*mx + t*t*b.x,
      y:  it*it*a.y + 2*it*t*my + t*t*b.y,
      tx: 2*it*(mx-a.x) + 2*t*(b.x-mx),
      ty: 2*it*(my-a.y) + 2*t*(b.y-my)
    };
  }

  function drawGlobe() {
    var gx = isMobile ? W * 0.5  : W * 0.76;
    var gy = isMobile ? H * 0.35 : H * 0.30;
    var R  = Math.min(
      W * (isMobile ? 0.44 : 0.28),
      H * (isMobile ? 0.22 : 0.38),
      isMobile ? 158 : 210
    );
    // Store params so drawCities() can place dots on the globe surface
    GLOBE_PARAMS.gx = gx; GLOBE_PARAMS.gy = gy; GLOBE_PARAMS.R = R;

    // Outer glow
    var glowR = R * (isMobile ? 1.6 : 1.5);
    var glowA = isMobile ? 0.42 : 0.28;
    var glow = ctx.createRadialGradient(gx, gy, R * 0.4, gx, gy, glowR);
    glow.addColorStop(0, 'rgba(37,99,235,' + glowA + ')');
    glow.addColorStop(0.5, 'rgba(37,99,235,' + (glowA * 0.4) + ')');
    glow.addColorStop(1, 'rgba(37,99,235,0)');
    ctx.beginPath(); ctx.arc(gx, gy, glowR, 0, Math.PI*2);
    ctx.fillStyle = glow; ctx.fill();

    // Globe fill
    var fill = ctx.createRadialGradient(gx - R*0.25, gy - R*0.2, 0, gx, gy, R);
    fill.addColorStop(0, isMobile ? 'rgba(37,99,235,0.55)' : 'rgba(37,99,235,0.50)');
    fill.addColorStop(0.6, isMobile ? 'rgba(37,99,235,0.38)' : 'rgba(37,99,235,0.32)');
    fill.addColorStop(1, isMobile ? 'rgba(37,99,235,0.14)' : 'rgba(37,99,235,0.10)');
    ctx.beginPath(); ctx.arc(gx, gy, R, 0, Math.PI*2);
    ctx.fillStyle = fill; ctx.fill();

    // Grid lines clipped inside globe
    ctx.save();
    ctx.beginPath(); ctx.arc(gx, gy, R, 0, Math.PI*2); ctx.clip();

    var latStep  = isMobile ? 45 : 30;
    var longCount = isMobile ? 6 : 9;
    ctx.strokeStyle = isMobile ? 'rgba(37,99,235,0.5)' : 'rgba(37,99,235,0.42)'; ctx.lineWidth = 1;
    for (var lat = -75; lat <= 75; lat += latStep) {
      var yr = R * Math.sin(lat * Math.PI / 180);
      var xr = R * Math.cos(lat * Math.PI / 180);
      ctx.beginPath(); ctx.ellipse(gx, gy + yr, xr, xr * 0.15, 0, 0, Math.PI*2); ctx.stroke();
    }
    ctx.strokeStyle = isMobile ? 'rgba(37,99,235,0.42)' : 'rgba(37,99,235,0.35)';
    for (var i = 0; i < longCount; i++) {
      var ang = (i / longCount) * Math.PI + T * 0.003;
      ctx.beginPath(); ctx.ellipse(gx, gy, Math.abs(Math.cos(ang)) * R, R, 0, 0, Math.PI*2); ctx.stroke();
    }
    ctx.restore();

    // Rim
    ctx.beginPath(); ctx.arc(gx, gy, R, 0, Math.PI*2);
    ctx.strokeStyle = isMobile ? 'rgba(37,99,235,0.65)' : 'rgba(37,99,235,0.60)'; ctx.lineWidth = isMobile ? 2.5 : 2.5; ctx.stroke();

    return { gx: gx, gy: gy, R: R };
  }

  function drawRoutes() {
    // Mobile: 3 routes spanning full canvas width (China cities right → Beirut left)
    var routes = isMobile ? [ROUTES[0], ROUTES[1], ROUTES[2]] : ROUTES;
    routes.forEach(function(r, ri) {
      var a = cityPx(r[0]), b = cityPx(r[1]);
      var mx = (a.x + b.x) / 2, my = Math.min(a.y, b.y) - H * (isMobile ? 0.16 : 0.22);
      // Glow pass (desktop only)
      if (!isMobile) {
        ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.quadraticCurveTo(mx, my, b.x, b.y);
        ctx.strokeStyle = 'rgba(37,99,235,0.12)'; ctx.lineWidth = 4;
        ctx.setLineDash([]); ctx.stroke();
      }
      // Main dashed line
      ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.quadraticCurveTo(mx, my, b.x, b.y);
      ctx.strokeStyle = isMobile ? 'rgba(37,99,235,0.22)' : 'rgba(37,99,235,0.38)';
      ctx.lineWidth = isMobile ? 1.2 : 1.6;
      ctx.setLineDash([6, 6]); ctx.stroke(); ctx.setLineDash([]);
    });
  }

  function drawCities() {
    var idxs = isMobile ? [0, 2, 3, 4, 5] : [0,1,2,3,4,5];
    var labels = ['Beijing','Shanghai','Guangzhou','Istanbul','Dubai','Beirut'];
    idxs.forEach(function(i) {
      var px = cityPx(i);
      var isBeirut = (i === 5);
      var r = isBeirut ? (isMobile ? 4 : 5.5) : (isMobile ? 2.5 : 3.5);
      // Dot
      ctx.beginPath(); ctx.arc(px.x, px.y, r, 0, Math.PI*2);
      ctx.fillStyle = isBeirut ? 'rgba(37,99,235,0.85)' : 'rgba(37,99,235,0.55)'; ctx.fill();
      // White center for Beirut
      if (isBeirut) {
        ctx.beginPath(); ctx.arc(px.x, px.y, r * 0.45, 0, Math.PI*2);
        ctx.fillStyle = 'rgba(255,255,255,0.9)'; ctx.fill();
      }
      // Pulse ring on Beirut
      if (isBeirut) {
        var pulse = (Math.sin(T * 0.05) + 1) / 2;
        ctx.beginPath(); ctx.arc(px.x, px.y, r + 2 + pulse * 10, 0, Math.PI*2);
        ctx.strokeStyle = 'rgba(37,99,235,' + (0.4 * (1 - pulse)) + ')'; ctx.lineWidth = 1.5; ctx.stroke();
      }
      // City labels — smaller font on mobile
      ctx.font = isBeirut
        ? (isMobile ? '700 9px Inter,sans-serif' : '700 11px Inter,sans-serif')
        : (isMobile ? '500 8px Inter,sans-serif'  : '500 10px Inter,sans-serif');
      ctx.fillStyle = isBeirut ? 'rgba(37,99,235,0.9)' : 'rgba(15,23,42,0.45)';
      ctx.fillText(labels[i], px.x + r + 4, px.y + 4);
    });
  }

  function drawPlane(x, y, angle, size) {
    ctx.save(); ctx.translate(x, y); ctx.rotate(angle);
    ctx.fillStyle = isMobile ? 'rgba(37,99,235,0.45)' : 'rgba(37,99,235,0.3)';
    ctx.beginPath(); ctx.moveTo(size, 0); ctx.lineTo(-size*0.5, -size*0.22); ctx.lineTo(-size*0.35, 0); ctx.lineTo(-size*0.5, size*0.22); ctx.closePath(); ctx.fill();
    ctx.beginPath(); ctx.moveTo(size*0.05, 0); ctx.lineTo(-size*0.1, -size*0.7); ctx.lineTo(-size*0.42, -size*0.12); ctx.closePath(); ctx.fill();
    ctx.beginPath(); ctx.moveTo(size*0.05, 0); ctx.lineTo(-size*0.1, size*0.7); ctx.lineTo(-size*0.42, size*0.12); ctx.closePath(); ctx.fill();
    ctx.beginPath(); ctx.moveTo(-size*0.3, 0); ctx.lineTo(-size*0.58, -size*0.32); ctx.lineTo(-size*0.52, 0); ctx.closePath(); ctx.fill();
    ctx.restore();
  }

  function drawShip(x, y, size) {
    ctx.save(); ctx.translate(x, y);
    // Wake waves
    var waveOp = isMobile ? 0.20 : 0.14;
    for (var w = 0; w < 3; w++) {
      ctx.beginPath();
      ctx.moveTo(-size*0.8 - w*18, size*0.45);
      ctx.quadraticCurveTo(-size*1.5 - w*18, size*0.55 + Math.sin((T + w*20) * 0.08) * 2, -size*2.2 - w*18, size*0.45);
      ctx.strokeStyle = 'rgba(37,99,235,' + (waveOp - w*0.025) + ')';
      ctx.lineWidth = 1.5 - w*0.4; ctx.stroke();
    }
    // Hull
    var hullOp = isMobile ? 0.55 : 0.38;
    ctx.fillStyle = 'rgba(37,99,235,' + hullOp + ')';
    ctx.beginPath();
    ctx.moveTo(-size, size*0.15); ctx.lineTo(size*0.65, size*0.15);
    ctx.lineTo(size*0.95, size*0.45); ctx.lineTo(-size*1.1, size*0.45); ctx.closePath(); ctx.fill();
    ctx.beginPath(); ctx.rect(-size*0.45, -size*0.28, size*0.75, size*0.44); ctx.fill();
    ctx.beginPath(); ctx.rect(-size*0.08, -size*0.62, size*0.18, size*0.36); ctx.fill();
    // Smoke
    var smk = (T * 0.02) % 1;
    ctx.fillStyle = 'rgba(96,165,250,' + (0.12 * (1 - smk)) + ')';
    ctx.beginPath(); ctx.arc(-size*0.02 - smk*8, -size*0.65 - smk*20, size*0.1 + smk*size*0.15, 0, Math.PI*2); ctx.fill();
    ctx.restore();
  }

  function draw() {
    T++;
    ctx.clearRect(0, 0, W, H);

    drawGlobe();

    // Desktop: fade globe's left edge so it doesn't bleed into text column
    if (!isMobile) {
      ctx.save();
      ctx.globalCompositeOperation = 'destination-out';
      var lf = ctx.createLinearGradient(W * 0.36, 0, W * 0.56, 0);
      lf.addColorStop(0, 'rgba(0,0,0,1)');
      lf.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = lf;
      ctx.fillRect(0, 0, W * 0.56, H);
      ctx.restore();
    }

    // Routes removed (no planes)
    drawCities();

    // Planes: 2 on mobile only, none on desktop
    var activePlanes = []; // planes removed
    activePlanes.forEach(function(p) {
      p.t += p.spd;
      if (p.t > 1) p.t -= 1;
      var r = ROUTES[p.route];
      var pt = routePoint(r[0], r[1], p.t);
      var angle = Math.atan2(pt.ty, pt.tx);
      // Trail: 5 dots on mobile (visible but light), 8 on desktop
      var trailLen = isMobile ? 5 : 8;
      for (var ti = 1; ti <= trailLen; ti++) {
        var tpt = routePoint(r[0], r[1], Math.max(0, p.t - ti * 0.012));
        ctx.beginPath(); ctx.arc(tpt.x, tpt.y, 1.4 * (1 - ti/trailLen), 0, Math.PI*2);
        ctx.fillStyle = 'rgba(96,165,250,' + (0.2 * (1 - ti/trailLen)) + ')'; ctx.fill();
      }
      drawPlane(pt.x, pt.y, angle, p.size);
    });

    // Ships: desktop = 4 ships through globe body; mobile = 2 ships at bottom
    var desktopYs = [0.40, 0.52, 0.64, 0.44];
    var mobileYs  = [0.36, 0.44, 0.40, 0.48];
    var activeShips = isMobile ? SHIPS.slice(0, 2) : SHIPS;
    activeShips.forEach(function(s, si) {
      var shipY = isMobile ? mobileYs[si] : desktopYs[si];
      var shipSpd = isMobile ? s.spd * 1.8 : s.spd;
      var bob = Math.sin(T * 0.04 + shipY * 10) * (isMobile ? 1.8 : 2.5);
      s.x += shipSpd * W;
      // Both desktop and mobile: wrap from right back to left (full traverse)
      if (s.x > W + 160) s.x = -140;
      drawShip(s.x, shipY * H + bob, s.size);
    });

    RAF = requestAnimationFrame(draw);
  }

  window.addEventListener('resize', resize);
  resize(); draw();
})();

// SCROLL REVEAL
(function() {
  var rvObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('on'); rvObs.unobserve(e.target); } });
  }, { threshold: .1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.rv,.rv-l,.rv-r').forEach(function(el) { rvObs.observe(el); });
})();

// COUNTERS
function ecAnimateCount(el) {
  var t = parseInt(el.dataset.to);
  var dur = 2000;
  var s = performance.now();
  function tick(now) {
    var p = Math.min((now - s) / dur, 1);
    var e = 1 - Math.pow(1 - p, 3);
    el.textContent = Math.floor(e * t).toLocaleString();
    if (p < 1) requestAnimationFrame(tick);
    else el.textContent = t.toLocaleString();
  }
  requestAnimationFrame(tick);
}
(function() {
  var cObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(en) { if (en.isIntersecting) { ecAnimateCount(en.target); cObs.unobserve(en.target); } });
  }, { threshold: .5 });
  document.querySelectorAll('.ec-ctr').forEach(function(el) { cObs.observe(el); });
})();

// CALCULATOR — rates read from localStorage (set in Admin > Settings)
function ecGetRate(key, fallback) {
  var v = parseFloat(localStorage.getItem(key));
  return (v && v > 0) ? v : fallback;
}
function ecBuildRates(origin) {
  var o = origin || 'china';
  if (o === 'turkey') {
    return {
      air: {
        normal:    ecGetRate('ec_rate_air_tr_n', 0),
        clothes:   ecGetRate('ec_rate_air_tr_c', 0),
        batteries: ecGetRate('ec_rate_air_tr_b', 0),
        magnetic:  ecGetRate('ec_rate_air_tr_b', 0),
        liquid:    ecGetRate('ec_rate_air_tr_l', 0),
        cosmetics: ecGetRate('ec_rate_air_tr_l', 0),
        powder:    ecGetRate('ec_rate_air_tr_l', 0)
      },
      sea: {
        normal:    ecGetRate('ec_rate_tr_n', 0),
        clothes:   ecGetRate('ec_rate_tr_c', 0),
        batteries: ecGetRate('ec_rate_tr_s', 0),
        magnetic:  ecGetRate('ec_rate_tr_s', 0),
        liquid:    ecGetRate('ec_rate_tr_s', 0),
        cosmetics: ecGetRate('ec_rate_tr_s', 0),
        powder:    ecGetRate('ec_rate_tr_s', 0)
      }
    };
  }
  if (o === 'dubai') {
    return {
      air: {
        normal:    ecGetRate('ec_rate_air_ae_n', 0),
        clothes:   ecGetRate('ec_rate_air_ae_c', 0),
        batteries: ecGetRate('ec_rate_air_ae_b', 0),
        magnetic:  ecGetRate('ec_rate_air_ae_b', 0),
        liquid:    ecGetRate('ec_rate_air_ae_l', 0),
        cosmetics: ecGetRate('ec_rate_air_ae_l', 0),
        powder:    ecGetRate('ec_rate_air_ae_l', 0)
      },
      sea: {
        normal:    ecGetRate('ec_rate_ae_n', 0),
        clothes:   ecGetRate('ec_rate_ae_c', 0),
        batteries: ecGetRate('ec_rate_ae_s', 0),
        magnetic:  ecGetRate('ec_rate_ae_s', 0),
        liquid:    ecGetRate('ec_rate_ae_s', 0),
        cosmetics: ecGetRate('ec_rate_ae_s', 0),
        powder:    ecGetRate('ec_rate_ae_s', 0)
      }
    };
  }
  // Default: China
  return {
    air: {
      normal:    ecGetRate('ec_rate_air_n', 15.5),
      clothes:   ecGetRate('ec_rate_air_c', 17.5),
      batteries: ecGetRate('ec_rate_air_b', 19.5),
      magnetic:  ecGetRate('ec_rate_air_b', 19.5),
      liquid:    ecGetRate('ec_rate_air_l', 22),
      cosmetics: ecGetRate('ec_rate_air_l', 22),
      powder:    ecGetRate('ec_rate_air_l', 22)
    },
    sea: {
      normal:    ecGetRate('ec_rate_cn_n', 400),
      clothes:   ecGetRate('ec_rate_cn_c', 1200),
      batteries: ecGetRate('ec_rate_cn_s', 750),
      magnetic:  ecGetRate('ec_rate_cn_s', 750),
      liquid:    ecGetRate('ec_rate_cn_s', 750),
      cosmetics: ecGetRate('ec_rate_cn_s', 750),
      powder:    ecGetRate('ec_rate_cn_s', 750)
    }
  };
}
// Legacy globals kept for any other references
var AIR = { normal: 15.5, clothes: 17.5, batteries: 19.5, magnetic: 19.5, liquid: 22, cosmetics: 22, powder: 22 };
var SEA = { normal: 400, clothes: 1200, batteries: 750, magnetic: 750, liquid: 750, cosmetics: 750, powder: 750 };
var TNAME = { normal: 'Normal / General', clothes: 'Clothes / Textiles', batteries: 'Batteries / Electronics', magnetic: 'Magnetic Items', liquid: 'Liquid Items', cosmetics: 'Cosmetics / Beauty', powder: 'Powder Items' };

function ecCalcUpdate() {
  var origin = document.getElementById('ec-c-origin') ? document.getElementById('ec-c-origin').value : 'china';
  var method = document.getElementById('ec-c-method') ? document.getElementById('ec-c-method').value : 'air';
  var type = document.getElementById('ec-c-type') ? document.getElementById('ec-c-type').value : 'normal';
  var qty = parseFloat(document.getElementById('ec-c-qty') ? document.getElementById('ec-c-qty').value : 0) || 0;
  var empty = document.getElementById('ec-c-empty');
  var output = document.getElementById('ec-c-output');
  var lbl = document.getElementById('ec-qty-label');
  if (lbl) lbl.textContent = method === 'air' ? 'Weight (kg)' : 'Volume (CBM)';
  if (!empty || !output) return;
  if (origin !== 'china') {
    empty.innerHTML = '<div style="font-size:40px;opacity:.4">🌍</div><div style="font-size:14px;line-height:1.7;color:rgba(15,23,42,.4)">Turkey & Dubai rates vary by route.<br><strong style="color:#1D4ED8">WhatsApp us for an instant quote.</strong></div>';
    empty.style.display = 'flex'; output.style.display = 'none'; return;
  }
  if (!qty) { empty.style.display = 'flex'; output.style.display = 'none'; return; }
  var rateSet = ecBuildRates(origin);
  var rates = method === 'air' ? rateSet.air : rateSet.sea;
  var rate = rates[type];
  var total = rate * qty;
  var unit = method === 'air' ? 'kg' : 'CBM';
  empty.style.display = 'none'; output.style.display = 'block';
  var amEl = document.getElementById('ec-cr-amount');
  if (amEl) amEl.textContent = '$' + Math.round(total).toLocaleString();
  var unitEl = document.getElementById('ec-cr-unit');
  if (unitEl) unitEl.textContent = qty + ' ' + unit + ' · ' + TNAME[type] + ' · ' + (method === 'air' ? 'Air Freight' : 'Sea Freight');
  var bd = '<div class="ec-cr-line"><span>Rate</span><span>$' + rate + '/' + unit + '</span></div>';
  bd += '<div class="ec-cr-line"><span>Shipping</span><span>$' + Math.round(total).toLocaleString() + '</span></div>';
  bd += '<div class="ec-cr-line tot"><span>Estimated Total</span><span>$' + Math.round(total).toLocaleString() + '</span></div>';
  var bkEl = document.getElementById('ec-cr-breakdown');
  if (bkEl) bkEl.innerHTML = bd;
  var msg = 'Hi EasyChina! I\'d like a quote:\n• Origin: China\n• Method: ' + (method === 'air' ? 'Air Freight' : 'Sea Freight') + '\n• Type: ' + TNAME[type] + '\n• ' + unit + ': ' + qty + '\n• My estimate: ~$' + Math.round(total).toLocaleString() + '\n\nPlease confirm exact price.';
  var waEl = document.getElementById('ec-c-wa');
  if (waEl) waEl.href = 'https://wa.me/96171749369?text=' + encodeURIComponent(msg);
  // Update rate reference display
  var refEl = document.querySelector('.ec-rate-ref');
  if (refEl) {
    var cnRates = ecBuildRates('china');
    var airN  = cnRates.air.normal, airC = cnRates.air.clothes;
    var airB  = cnRates.air.batteries, airL = cnRates.air.liquid;
    var seaN  = cnRates.sea.normal, seaC = cnRates.sea.clothes, seaS = cnRates.sea.batteries;
    var txt = '<strong>Air ($/kg):</strong> Normal ' + airN + ' · Clothes ' + airC + ' · Batteries/Magnetic ' + airB + ' · Liquid/Cosmetics/Powder ' + airL + '<br>';
    txt += '<strong>Sea ($/CBM):</strong> Normal ' + seaN + ' · Clothes ' + seaC + ' · Batteries/Magnetic/Liquid/Cosmetics/Powder ' + seaS;
    refEl.innerHTML = txt;
  }
}

// QUOTE FORM
function ecSendQuote() {
  var name = (document.getElementById('ec-qf-name') ? document.getElementById('ec-qf-name').value.trim() : '') || '(not provided)';
  var phone = (document.getElementById('ec-qf-phone') ? document.getElementById('ec-qf-phone').value.trim() : '') || '(not provided)';
  var origin = document.getElementById('ec-qf-origin') ? document.getElementById('ec-qf-origin').value : '';
  var method = document.getElementById('ec-qf-method') ? document.getElementById('ec-qf-method').value : '';
  var prod = document.getElementById('ec-qf-prod') ? document.getElementById('ec-qf-prod').value : '';
  var msg = document.getElementById('ec-qf-msg') ? document.getElementById('ec-qf-msg').value.trim() : '';
  var text = 'Hi EasyChina! I\'d like a quote:\n\nName: ' + name + '\nPhone: ' + phone + '\nOrigin: ' + origin + '\nMethod: ' + method + '\nProduct: ' + prod + (msg ? '\n\nExtra info: ' + msg : '');
  window.open('https://wa.me/96171749369?text=' + encodeURIComponent(text), '_blank');
}
